import type { FunctionComponent, PropsWithChildren } from 'react';
import styled from 'styled-components';
import { Tooltip, paletteHelper } from '@property.com.au/ui-kit';
import { trackDisclaimerModalOpen } from '../../../analytics/event-tracking/trackDisclaimerModalOpen';
import { useHandleOnHoverOnce } from '../../../hooks/useHandleOnHoverOnce';

const StyledTooltip = styled(Tooltip)<{ narrow?: boolean }>`
  > * {
    &:focus,
    &:focus-within,
    &:hover {
      background-color: transparent;
      color: ${paletteHelper('textSecondary')};
    }
  }

  .contentWrapper {
    ${({ narrow }) => narrow && 'max-width: 14rem'};
  }
`;

interface StyledQuestionTooltipProps {
  inPageSource: string;
  narrow?: boolean;
}

export const StyledQuestionTooltip: FunctionComponent<
  PropsWithChildren<StyledQuestionTooltipProps>
> = ({ inPageSource, narrow, children }) => {
  const { handleOnHover } = useHandleOnHoverOnce(() => {
    trackDisclaimerModalOpen({ inPageSource });
  });

  return (
    <StyledTooltip
      placement="bottom-end"
      variant="question"
      onOpen={handleOnHover}
      narrow={narrow}
      sizeVariant="large"
      dangerouslySetClassNames={{
        contentWrapper: 'contentWrapper',
      }}
    >
      {children}
    </StyledTooltip>
  );
};
